const changeIdCard = (idcard) => {
    let idcards = idcard.toString()
    // if (!checkIdCard(idcards)) {
    //     return idcards;
    // }
    idcards = idcards.substring(0, 4)+'**********' + idcards.substring(idcards.length - 4, idcards.length)

    return idcards;
}

export default changeIdCard;


// WEBPACK FOOTER //
// ./src/utils/changeIdCard.js